import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ChatChannelModel } from '@smarttask-common/src/lib/models/Chat/Channel/ChatChannelModel';

export enum ChatChannelActionTypes {
    ADD_CHATCHANNEL = '[ChatChannel] Add ChatChannel',
    ADD_CHATCHANNELS = '[ChatChannel] Add ChatChannels',
    UPSERT_CHATCHANNEL = '[ChatChannel] Upsert ChatChannel',
    UPSERT_CHATCHANNELS = '[ChatChannel] Upsert ChatChannels',
    UPDATE_CHATCHANNEL = '[ChatChannel] Update ChatChannel',
    UPDATE_CHATCHANNELS = '[ChatChannel] Update ChatChannels',
    DELETE_CHATCHANNEL = '[ChatChannel] Delete ChatChannel',
    DELETE_CHATCHANNELS = '[ChatChannel] Delete ChatChannels',
    DELETE_ALL_CHATCHANNELS = '[ChatChannel] Delete All ChatChannels',
    DELETE_ALL = '[ChatChannel] Delete All',

    UPDATE_SELECTED_ID = '[ChatChannel] Update SelectedId',
}

export class UpdateSelectedChatChannelId implements Action {
    readonly type = ChatChannelActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_channel_id: string) {}
}

export class AddOne implements Action {
    readonly type = ChatChannelActionTypes.ADD_CHATCHANNEL;
    constructor(public channel: ChatChannelModel) {}
}

export class AddMany implements Action {
    readonly type = ChatChannelActionTypes.ADD_CHATCHANNELS;
    constructor(public channels: Array<ChatChannelModel>) {}
}

export class UpsertOne implements Action {
    readonly type = ChatChannelActionTypes.UPSERT_CHATCHANNEL;

    constructor(public channel: ChatChannelModel) {}
}

export class UpsertMany implements Action {
    readonly type = ChatChannelActionTypes.UPSERT_CHATCHANNELS;
    constructor(public channels: Array<ChatChannelModel>) {}
}

export class UpdateOne implements Action {
    readonly type = ChatChannelActionTypes.UPDATE_CHATCHANNEL;
    constructor(public channel: Update<ChatChannelModel>) {}
}

export class UpdateMany implements Action {
    readonly type = ChatChannelActionTypes.UPDATE_CHATCHANNELS;
    constructor(public channels: Array<Update<ChatChannelModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = ChatChannelActionTypes.DELETE_CHATCHANNEL;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = ChatChannelActionTypes.DELETE_CHATCHANNELS;
    constructor(public ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = ChatChannelActionTypes.DELETE_ALL_CHATCHANNELS;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = ChatChannelActionTypes.DELETE_ALL;
    constructor() {}
}

export type ChatChannelActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedChatChannelId;
